import style from "./style.module.css";
import React, { useEffect, useRef, useState, useContext } from "react";
import ReactCodeInput from "react-verification-code-input-2";
import { NotificationContext } from "../../../contexts/NotificationContext";
import { TServiceResponse } from "../../../services/Modals";
import { TSendOtpData } from "../../../services/Auth/types";
import { TSendOtpForEmployeeValidationData } from "../../../services/Customer/types";

/**
 * handle customers's  mobile number validation by verifying otp.
 * @constructor
 */

interface IVarifyOtpProps {
    phone: string;
    email: string;
    isResendOtp: boolean;
    validityTime: number,
    showDefaultMsg?: boolean;
    onValidityExpire: () => any;
    setIsResendOtp: React.Dispatch<React.SetStateAction<boolean>>;
    sendOTPService: (phone:string, email: string) => Promise<TServiceResponse<TSendOtpData | TSendOtpForEmployeeValidationData | null>>,
    verifyOTPService: (phone:string, otp:string) => Promise<TServiceResponse<any>>,
}
export default function VerifyOtp(params: IVarifyOtpProps) {
    const { phone, email, setIsResendOtp, onValidityExpire, isResendOtp, validityTime, showDefaultMsg, sendOTPService, verifyOTPService } = params
    const inputRef = useRef()
    const [error, setError] = useState('')
    const [time, setTime] = useState(1);//initiate timer to 1
    const { notify } = useContext(NotificationContext)

    useEffect(() => {// for updating the time value after refreshing timer
        setTime(isResendOtp ? 0 : validityTime);//set to 0 if resend otp btn is active else assign timer to time
    }, [validityTime])


    useEffect(() => {
        const timerId = setInterval(() => onValidityUpdate(), 1000);
        if (time === 0) {
            setIsResendOtp(true)
        }
        if (time <= 0) {
            clearInterval(timerId);//stops the timer
        }
        return () => clearInterval(timerId)
    }, [time])

    const onValidityUpdate = () => {
        setTime((previousTime: any) => previousTime - 1000);//decrease the time by 1 minute
    }
    //clear code input
    const clearInput = () => {
        (inputRef?.current as any)?.__clearvalues__()
    }

    //handle verification of otp
    const verifyOtp = async (inputOtp: string) => {
        const { data, error } = await verifyOTPService(phone, inputOtp)
        if (error !== null) {
            setError(error.reason);
            clearInput();
        }else{
            if(!showDefaultMsg) {
                notify('Login Successful')
            }
        }
    }

    //handle Resend otp
    const resendOtp = async () => {
        const { error } = await sendOTPService(phone, email)
        if (error === null) {
            onValidityExpire();
            notify('OTP Sent')
            setIsResendOtp(false);
            setTime(validityTime)
        }
        clearInput()
    }


    return (
        <div className="container-center mb-4">
            <p className="font14 mb-4">Enter the OTP sent to +91-{phone}</p>
            {/*otp input field*/}
            <ReactCodeInput
                // @ts-ignore
                ref={inputRef}
                className={style.otpInput}
                fields={6}
                onComplete={verifyOtp}
            />

            <p className="font12 mt-2">
                Didn{'\''}t receive OTP?{' '}
                {isResendOtp ?
                    <span className={style.link}
                        onClick={resendOtp}>Request again</span>
                    :
                    <span className={style.link + " " + style.disable}>Request again</span>
                }
            </p>
            <span className={style.appTimer}>{getFormattedTime(time)}</span>
            <br />
            <div className={style.error}>{error}</div>
        </div>
    )

}


//format second to minute
const getFormattedTime = (validity: number) => {
    let minutes = Math.floor(validity / 60000)
    let seconds = Number(((validity % 60000) / 1000).toFixed(0))
    return seconds == 60 ? minutes + 1 + ':00' : minutes + ':' + (seconds < 10 ? '0' : '') + seconds
}